import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, delay, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CheckNumberIDInterface } from '../interfaces/check-number-id-interface';

@Injectable({
  providedIn: 'root'
})
export class CheckNumberIDValidatorsService implements AsyncValidator {
  private http = inject(HttpClient);

  numberIDTakeError: string | null = null;
  private baseUrl: string = environment.baseUrlAuth;

  validate(control: AbstractControl<CheckNumberIDInterface>): Observable<ValidationErrors | null> {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });


    const noIdentification  = control.value.noIdentification;

    // console.log('#ID',noIdentification)


    return this.http.get<CheckNumberIDInterface>(
      `${this.baseUrl}/api/auth/check-id?noIdentification=${noIdentification}&idTipoId=${noIdentification}`, { headers }
      )
      .pipe(
        tap( resp => {
          // console.log('respCheckID:',resp);
        }),
        map( (resp: CheckNumberIDInterface) => {
          if (resp?.id?.userExits === true){
            this.numberIDTakeError = `El ID: ${noIdentification} ya esta en uso`;
            return {
              numberIDTaken: true
            };
          } else {
            this.numberIDTakeError = null;
            return null;
          }
        }
      )).pipe(delay(1000));
  }



}


// map((resp: CheckNumberIDInterface) => {

//   if (resp?.id?.userExits === true){
//     this.numberIDTakeError = `El número de identificación: ${id} ya esta en uso`;
//     return {
//       numberIDTaken: true
//     };
//   }
